import actions from './moduleSearchActions';
import mutations from './moduleSearchMutations';
import getters from './moduleSearchGetters';
import state from './moduleSearchState';

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
